import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { useReviewsWorkspaceAccess } from "@redotech/redo-merchant-review-app/use-reviews-workspace-access";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";
import {
  REVIEWS_ICON,
  REVIEWS_ICON_FILLED,
} from "../../../../redo-suite/marketing-cloud";
import { ReviewsToReviewContext } from "../../../../services/marketing/reviews-to-review-service";

export const ReviewsItems = memo(function ReviewsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const reviewCount = useContext(ReviewsToReviewContext);

  const { nativeReviewsEnabled, workspaceAvailable } =
    useReviewsWorkspaceAccess();

  const reviewsBaseUrl = routes.marketingBaseUrl + "/reviews";
  const anyChildSelected = useMatch(`${reviewsBaseUrl}/*`);

  if (!workspaceAvailable) {
    return null;
  }

  const defaultRoute = nativeReviewsEnabled ? "dashboard" : "all-reviews";

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute(defaultRoute) }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={REVIEWS_ICON_FILLED}
      friendlyName="Reviews"
      id="reviews"
      notificationCount={reviewCount}
      UnfilledIcon={REVIEWS_ICON}
    >
      {nativeReviewsEnabled && <ReviewsDashboardItem />}
      <ReviewsAllReviewsItem />
      <ReviewsProductsItem />
      {nativeReviewsEnabled && (
        <>
          <ReviewsDisplaysWidgetsItem />
          <ReviewsResponseItem />
          <ReviewsSettingsItem />
        </>
      )}
    </RedoSecondaryNavItem>
  );
});

const ReviewsDashboardItem = memo(function ReviewsDashboardItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("dashboard") }}
      friendlyName="Dashboard"
      id="reviews-dashboard"
    />
  );
});

const ReviewsAllReviewsItem = memo(function ReviewsAllReviewsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("all-reviews") }}
      friendlyName="All reviews"
      id="reviews-all-reviews"
    />
  );
});

const ReviewsDisplaysWidgetsItem = memo(function ReviewsDisplaysWidgetsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getReviewsSubRoute("reviews-displays-widgets"),
      }}
      friendlyName="Displays & Widgets"
      id="reviews-displays-widgets"
    />
  );
});

const ReviewsProductsItem = memo(function ReviewsProductsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("products") }}
      friendlyName="Products"
      id="reviews-products"
    />
  );
});

const ReviewsResponseItem = memo(function ReviewsResponseItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getReviewsSubRoute("reviews-response"),
      }}
      friendlyName="Response"
      id="reviews-response"
    />
  );
});

const ReviewsSettingsItem = memo(function ReviewsSettingsItem() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getReviewsSubRoute("settings") }}
      friendlyName="Settings"
      id="reviews-settings"
    />
  );
});
